import { Component } from '@angular/core';

@Component({
  selector: 'mprd-order-fiber-boost-confirmation-modal',
  templateUrl: './order-fiber-boost-confirmation-modal.component.html',
})
export class OrderFiberBoostConfirmationModalComponent {
  public destroy: Function;
  public confirm: Function;
  public action: 'order' | 'cease';

  constructor() {}

  close() {
    this.destroy();
  }

  confirmOrder() {
    if (this.confirm) {
      this.confirm();
    }
    this.destroy();
  }
}
